import { type FlagCode } from '@doxyme/types';
import { IconBase, type IconProps, flags } from '@doxyme/icons';
import { useTheme } from '../../../theme';
import { Suspense, useEffect, useState, type JSX } from 'react';

// Note: I generated this spritesheet from individual icons exported from Figma
// using this online tool https://svg-sprite-generator.vercel.app/
// If new countries need to be added, I would advise using the same tool
// or add the new SVG manually into the symbol container.

export type FlagProps = IconProps & {
  flagCode: FlagCode;
};

export const Location = (properties: FlagProps): JSX.Element | null => {
  const { flagCode, ...svgProps } = properties;
  const theme = useTheme();
  const [flagComponent, setFlagComponent] = useState<JSX.Element | null>(null);

  useEffect(() => {
    const loadFlag = async (): Promise<void> => {
      try {
        const module = await flags[
          flagCode.toLowerCase() as keyof typeof flags
        ]();
        setFlagComponent(module.default);
      } catch (error) {
        console.error(`Error loading flag: ${flagCode}`, error);
        setFlagComponent(null);
      }
    };

    void loadFlag();
  }, [flagCode]);

  return (
    <Suspense>
      {flagComponent && (
        <IconBase
          viewBox='0 0 16 16'
          role='img'
          aria-label={svgProps['aria-label'] ?? flagCode}
          {...svgProps}
          style={{
            outline: `1px solid ${theme.location.border}`,
            borderRadius: '50%',
          }}
        >
          {flagComponent}
        </IconBase>
      )}
    </Suspense>
  );
};
